import React, { useEffect, useState } from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { kirkos_merchant_profile } from "../../../assets/images";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "../../../services/apiConfig";
import axiosInstance, { afl_log_out } from "../../../services/axios.instance";
import { CustomerDetails } from "../../../types";

interface Props {
  currentPage: string;
}

const VendorNavbar: React.FC<Props> = ({ currentPage }) => {
  const [showProfile, setShowProfile] = useState(false);
  const [profileImage, setProfileImage] = useState<string>(
    kirkos_merchant_profile
  );

  // Fetch merchant details
  useQuery<CustomerDetails, Error>({
    queryKey: ["navprofiledetails"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.CUSTOMER_DETAILS);
      const details = response.data;
      setProfileImage(details?.merchant_details?.siteLogo);
      return details;
    },
  });

  const handleProfile = () => {
    setShowProfile(!showProfile);
  };

  // Decode token
  const decodeToken = (token: string | null) => {
    if (!token) return null;
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch {
      return null;
    }
  };

  const accessToken = localStorage.getItem("access_token");
  const decodedToken = decodeToken(accessToken);

  // Logout and redirect merchant
  const handleLogout = () => {
    const roles = decodedToken?.roles || [];

    afl_log_out().finally(() => {
      if (roles.includes("ROLE_MERCHANT")) {
        window.location.href = "/vendor";
      } else {
        window.location.href = "/";
      }
    });
  };

  return (
    <div className="nav-bar-style">
      <Navbar
        expand="lg"
        className="nav-pills navbar-light nav-tab-style justify-content-end"
      >
        <Navbar.Collapse>
          <div className="col navheaderdiv">
            <Navbar.Brand href="#" className="navbar-brand-style">
              {currentPage === "dashboard"
                ? "Dashboard"
                : currentPage === "servicelist"
                ? "Manage Services / Listings"
                : currentPage === "servicecreation"
                ? "Create Service / Request"
                : currentPage === "driverapproval"
                ? "Driver Approval"
                : ""}
            </Navbar.Brand>

            <Navbar.Text>
              <a className="nav-link brand-bottom" href="#">
                {currentPage === "servicelist" ? (
                  <span>
                    <span className="brand-bottom-first">Dashboard &gt; </span>
                    <span className="navspan-bg-color">
                      Manage Services / Listings
                    </span>
                  </span>
                ) : currentPage === "servicecreation" ? (
                  <>
                    <span className="brand-bottom-first">
                      Dashboard&nbsp;&gt;&nbsp;&nbsp;&gt;&nbsp;
                    </span>
                    <span className="navspan-bg-color">
                      Create Service / Request
                    </span>
                  </>
                ) : currentPage === "driverapproval" ? (
                  <>
                    <span className="brand-bottom-first">
                      Dashboard&nbsp;&gt;&nbsp;&nbsp;&gt;&nbsp;
                    </span>
                    <span className="navspan-bg-color">Driver Approval</span>
                  </>
                ) : null}
              </a>
            </Navbar.Text>
          </div>
        </Navbar.Collapse>

        <Nav className="right-side-nav justify-content-end">
          <div className="justify-content-end d-inline-flex">
            {/* Profile Dropdown */}
            <Dropdown show={showProfile} onToggle={handleProfile}>
              <Dropdown.Toggle
                id="dropdown-basic"
                className="profile-hover pt-1 px-2 profile-afl"
              >
                <img
                  src={profileImage || kirkos_merchant_profile}
                  className="rounded-pill profile-logo"
                  alt="profile"
                />
                <span className="custom-d-none-navbar">
                  &nbsp;
                  {decodedToken?.roles?.includes("ROLE_MERCHANT")
                    ? "Merchant"
                    : ""}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="display-drop-down">
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Nav>
      </Navbar>
    </div>
  );
};

export default VendorNavbar;
